export default "__VITE_ASSET__CW7w1nCb__"